const NBSP_THIN = ' ';

export function formatInt(n: number | null | undefined): string {
  if (n == null || Number.isNaN(n)) return '0';
  // On force le séparateur : Intl rend U+202F sur certaines plateformes et
  // U+00A0 sur d'autres, ce qui rend les tests non déterministes en CI.
  return Math.round(n)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, NBSP_THIN);
}

export function formatPct(ratio: number | null | undefined): string {
  if (ratio == null || Number.isNaN(ratio)) return `0${NBSP_THIN}%`;
  const clamped = Math.max(0, Math.min(1, ratio));
  return `${Math.round(clamped * 100)}${NBSP_THIN}%`;
}

export function formatDuration(seconds: number | null | undefined): string {
  if (seconds == null || Number.isNaN(seconds) || seconds < 0) return '—';
  const s = Math.round(seconds);
  if (s < 3600) {
    const m = Math.floor(s / 60);
    const rest = s % 60;
    return `${m} min ${String(rest).padStart(2, '0')} s`;
  }
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  return `${h} h ${String(m).padStart(2, '0')} min`;
}

export function formatRelative(iso: string | null | undefined, now: Date = new Date()): string {
  if (!iso) return '—';
  const diff = (now.getTime() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return 'à l’instant';
  if (diff < 3600) return `il y a ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `il y a ${Math.floor(diff / 3600)} h`;
  return `il y a ${Math.floor(diff / 86400)} j`;
}
